import React, { FC } from "react";
import { useRouter } from "next/router";

export const JoinOurTeam: FC = () => {
  const router = useRouter();

  React.useEffect(() => {
    window.open("https://payall.bamboohr.com/careers", "_blank");
    router.back();
  }, []);

  return null;
};
